var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"mr-1 mb-1",attrs:{"small":""}},on),[_vm._v("mdi-information-outline")])]}}])},[_c('span',[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }